export default (function (date) {
  if (!date) return false;
  var eventDate = new Date(String(date.replace(' ', 'T'))).getTime(); // for Safari as it only accepts formats like this '2018-05-02T14:00:00'
  var currentDate = new Date().getTime();
  return eventDate - currentDate < 0;
});